import PropTypes from "prop-types";
import * as React from "react";
import { CheckIcon } from "../../themeV2";
import SignTypeChip from "../SignTypeChip/SignTypeChip";
import styles from "./SignTypeBadge.module.css";

const SignTypeBadge = React.memo(function SignTypeBadge({
  active = true,
  disabled,
  label,
  onClick,
  pressed,
  signedType,
  className,
}) {
  const isInteractive = Boolean(onClick);
  const isInactive = disabled || active === false;

  const classes = [isInactive && styles.inactive, className]
    .filter(Boolean)
    .join(" ");

  const chip = (
    <SignTypeChip signedType={signedType} label={label} className={classes} />
  );

  return isInteractive ? (
    <button
      type="button"
      className={[styles.button, pressed && styles.pressed]
        .filter(Boolean)
        .join(" ")}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={pressed}
    >
      {pressed && <CheckIcon className={styles.check} />}
      {chip}
    </button>
  ) : (
    chip
  );
});

SignTypeBadge.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  pressed: PropTypes.bool,
  signedType: PropTypes.string.isRequired,
};

/** @deprecated Use CSS Modules positioning instead */
export const TopRight = React.forwardRef(function TopRight(
  { children, style, className },
  ref,
) {
  return (
    <div
      ref={ref}
      className={[styles.topRight, className].filter(Boolean).join(" ")}
      style={style}
    >
      {children}
    </div>
  );
});
TopRight.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default SignTypeBadge;
